import React from 'react';

const navSections = [
  {
    label: 'OVERVIEW',
    items: [
      { key: 'dashboard', label: 'Dashboard', icon: 'fa-solid fa-gauge', roles: ['super_admin', 'manager', 'support'] },
    ],
  },
  {
    label: 'MANAGEMENT',
    items: [
      { key: 'subscriptions', label: 'Subscriptions', icon: 'fa-solid fa-credit-card', roles: ['super_admin', 'manager', 'support'] },
      { key: 'customers', label: 'Customers', icon: 'fa-solid fa-address-book', roles: ['super_admin', 'manager', 'support'] },
      { key: 'deployments', label: 'Deployments', icon: 'fa-solid fa-rocket', roles: ['super_admin', 'manager'] },
      { key: 'servers', label: 'Servers', icon: 'fa-solid fa-server', roles: ['super_admin'] },
    ],
  },
  {
    label: 'CATALOG',
    items: [
      { key: 'plans', label: 'Plans', icon: 'fa-solid fa-cubes', roles: ['super_admin', 'manager'] },
      { key: 'offers', label: 'Offers', icon: 'fa-solid fa-tags', roles: ['super_admin', 'manager'] },
    ],
  },
  {
    label: 'ENGAGEMENT',
    items: [
      { key: 'affiliates', label: 'Affiliates', icon: 'fa-solid fa-users', roles: ['super_admin', 'manager'] },
      { key: 'waitlist', label: 'Waitlist', icon: 'fa-solid fa-list-check', roles: ['super_admin', 'manager'] },
      { key: 'support', label: 'Support', icon: 'fa-solid fa-headset', roles: ['super_admin', 'manager', 'support'] },
      { key: 'emaillogs', label: 'Email Logs', icon: 'fa-solid fa-envelope-open-text', roles: ['super_admin', 'manager'] },
      { key: 'announcements', label: 'Announcements', icon: 'fa-solid fa-bullhorn', roles: ['super_admin', 'manager'] },
      { key: 'emailqueue', label: 'Email Queue', icon: 'fa-solid fa-clock', roles: ['super_admin', 'manager'] },
    ],
  },
  {
    label: 'TOOLS',
    items: [
      { key: 'migration', label: 'Migration', icon: 'fa-solid fa-right-left', roles: ['super_admin', 'manager'] },
    ],
  },
  {
    label: 'ANALYTICS',
    items: [
      { key: 'analytics', label: 'Attribution', icon: 'fa-solid fa-chart-pie', roles: ['super_admin', 'manager'] },
      { key: 'revenue', label: 'Revenue', icon: 'fa-solid fa-chart-line', roles: ['super_admin'] },
      { key: 'monitoring', label: 'Monitoring', icon: 'fa-solid fa-heartbeat', roles: ['super_admin'] },
      { key: 'cancellations', label: 'Cancellations', icon: 'fa-solid fa-person-walking-arrow-right', roles: ['super_admin', 'manager'] },
    ],
  },
  {
    label: 'SYSTEM',
    items: [
      { key: 'users', label: 'Admin Users', icon: 'fa-solid fa-user-shield', roles: ['super_admin'] },
      { key: 'auditlog', label: 'Audit Log', icon: 'fa-solid fa-clipboard-list', roles: ['super_admin'] },
      { key: 'apikeys', label: 'API Keys', icon: 'fa-solid fa-key', roles: ['super_admin'] },
      { key: 'settings', label: 'Settings', icon: 'fa-solid fa-sliders', roles: ['super_admin'] },
    ],
  },
];

function AdminSidebar({ activeSection, onNavigate, collapsed, onToggleCollapse, mobileOpen, adminUser, badges = {} }) {
  const role = adminUser?.role || 'super_admin';
  const displayName = adminUser?.full_name || 'Admin';
  const displayRole = role.replace('_', ' ');
  const initials = displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'A';

  const filteredSections = navSections
    .map(section => ({
      ...section,
      items: section.items.filter(item => item.roles.includes(role)),
    }))
    .filter(section => section.items.length > 0);

  return (
    <div className={`admin-sidebar${collapsed ? ' collapsed' : ''}${mobileOpen ? ' open' : ''}`}>
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-logo">
          {collapsed
            ? <img src="/openhosst-favicon.png" alt="OpenHosst" className="admin-sidebar-logo-favicon" />
            : <img src="/logo-dark.png" alt="OpenHosst" className="admin-sidebar-logo-img" />
          }
        </div>
        <button className="admin-sidebar-toggle" onClick={onToggleCollapse} title={collapsed ? 'Expand' : 'Collapse'}>
          <i className={collapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-left'} style={{ fontSize: '12px' }} />
        </button>
      </div>

      <nav className="admin-sidebar-nav">
        {filteredSections.map((section) => (
          <div key={section.label}>
            {!collapsed && <div className="admin-sidebar-section-label">{section.label}</div>}
            {section.items.map((item) => {
              const count = badges[item.key] || 0;
              return (
              <button
                key={item.key}
                className={`admin-sidebar-item${activeSection === item.key ? ' active' : ''}`}
                onClick={() => onNavigate(item.key)}
                data-tooltip={count > 0 ? `${item.label} (${count})` : item.label}
              >
                <span className="icon" style={{ position: 'relative' }}>
                  <i className={item.icon} />
                  {count > 0 && collapsed && (
                    <span style={{ position: 'absolute', top: '-3px', right: '-5px', width: '8px', height: '8px', borderRadius: '50%', background: '#ef4444', border: '1px solid var(--admin-sidebar-bg, #111)' }} />
                  )}
                </span>
                {!collapsed && <span className="label">{item.label}</span>}
                {!collapsed && count > 0 && (
                  <span style={{ marginLeft: 'auto', minWidth: '18px', height: '18px', padding: '0 5px', borderRadius: '9px', background: '#ef4444', color: '#fff', fontSize: '10px', fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{count}</span>
                )}
              </button>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="admin-sidebar-footer">
        <div className="admin-sidebar-avatar">{initials}</div>
        {!collapsed && (
          <div className="admin-sidebar-userinfo">
            <div className="admin-sidebar-username">{displayName}</div>
            <div className="admin-sidebar-role">{displayRole}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminSidebar;
